var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDocumentNoBackground = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 61,
    viewBox: "0 0 54 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.43 0.5H39.573C48.84 0.5 54 5.84 54 14.99V45.98C54 55.28 48.84 60.5 39.573 60.5H14.43C5.31 60.5 0 55.28 0 45.98V14.99C0 5.84 5.31 0.5 14.43 0.5ZM15.24 14.48V14.45H24.207C25.5 14.45 26.55 15.5 26.55 16.787C26.55 18.11 25.5 19.16 24.207 19.16H15.24C13.947 19.16 12.9 18.11 12.9 16.82C12.9 15.53 13.947 14.48 15.24 14.48ZM15.24 32.72H38.76C40.05 32.72 41.1 31.67 41.1 30.38C41.1 29.09 40.05 28.037 38.76 28.037H15.24C13.947 28.037 12.9 29.09 12.9 30.38C12.9 31.67 13.947 32.72 15.24 32.72ZM15.24 46.43H38.76C39.957 46.31 40.86 45.287 40.86 44.09C40.86 42.86 39.957 41.84 38.76 41.72H15.24C14.34 41.63 13.47 42.05 12.99 42.83C12.51 43.58 12.51 44.57 12.99 45.35C13.47 46.1 14.34 46.55 15.24 46.43Z",
    fill: "#0F0F0F"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocumentNoBackground, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DocumentNoBackground.282b8c4e.svg";
export { ForwardRef as ReactComponent };